import React, { ChangeEvent } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { LinkThreeData } from "../../../types";
import { InfoTooltip } from "./LinksInfoTooltip";

interface LinksColorsSectionProps {
  open: boolean;
  onToggle: () => void;
  data: LinkThreeData;
  onChange: (data: LinkThreeData) => void;
}

export function LinksColorsSection({
  open,
  onToggle,
  data,
  onChange,
}: LinksColorsSectionProps) {
  return (
    <div className="mb-8">
      <button
        type="button"
        className="group flex w-full items-center justify-between rounded-xl border border-stroke bg-gray-50 p-5 transition-all hover:bg-gray-100 hover:shadow-sm dark:border-strokedark dark:bg-meta-4 dark:hover:bg-opacity-80"
        onClick={onToggle}
      >
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-white dark:bg-boxdark">
            {open ? (
              <FiEyeOff
                size={18}
                className="text-gray-600 dark:text-gray-400"
              />
            ) : (
              <FiEye size={18} className="text-gray-600 dark:text-gray-400" />
            )}
          </div>
          <div className="flex items-center">
            <span className="font-semibold text-black dark:text-white">
              Personalizar Cores
            </span>
            <InfoTooltip
              id="color-customization"
              text="Personalize as cores dos botões, texto e fundo da sua página de links para combinar com sua marca."
            />
          </div>
        </div>
        <div
          className={`transform transition-transform ${open ? "rotate-180" : ""}`}
        >
          <svg
            className="h-5 w-5 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </button>

      {open && (
        <div className="mt-4 grid grid-cols-1 gap-5 rounded-xl border border-stroke bg-gradient-to-br from-gray-50 to-gray-100 p-6 dark:border-strokedark dark:from-meta-4 dark:to-gray-800 sm:grid-cols-3">
          <div>
            <label className="mb-3 flex items-center text-sm font-semibold text-black dark:text-white">
              Cor dos Botões
              <InfoTooltip
              id="button-color"
              text="Cor de fundo dos botões de link"
            />
            </label>
            <div className="relative">
              <input
                type="color"
                value={data?.color || "#3C50E0"}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  onChange({ ...data, color: e.target.value })
                }
                className="h-12 w-full cursor-pointer rounded-lg border-2 border-stroke transition hover:border-purple-400 dark:border-strokedark"
              />
              <div
                className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-6 w-6 rounded border-2 border-white shadow-sm"
                style={{
                  backgroundColor: data?.color || "#3C50E0",
                }}
              />
            </div>
          </div>
          <div>
            <label className="mb-3 flex items-center text-sm font-semibold text-black dark:text-white">
              Cor do Texto
              <InfoTooltip
                id="text-color"
                text="Cor do texto dentro dos botões"
              />
            </label>
            <div className="relative">
              <input
                type="color"
                value={data?.color_secondary || "#FFFFFF"}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  onChange({
                    ...data,
                    color_secondary: e.target.value,
                  })
                }
                className="h-12 w-full cursor-pointer rounded-lg border-2 border-stroke transition hover:border-purple-400 dark:border-strokedark"
              />
              <div
                className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-6 w-6 rounded border-2 border-white shadow-sm"
                style={{
                  backgroundColor: data?.color_secondary || "#FFFFFF",
                }}
              />
            </div>
          </div>
          <div>
            <label className="mb-3 flex items-center text-sm font-semibold text-black dark:text-white">
              Cor de Fundo
              <InfoTooltip
                id="bg-color"
                text="Cor de fundo da página de links"
              />
            </label>
            <div className="relative">
              <input
                type="color"
                value={data?.background || "#0F172A"}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  onChange({
                    ...data,
                    background: e.target.value,
                  })
                }
                className="h-12 w-full cursor-pointer rounded-lg border-2 border-stroke transition hover:border-purple-400 dark:border-strokedark"
              />
              <div
                className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-6 w-6 rounded border-2 border-white shadow-sm"
                style={{
                  backgroundColor: data?.background || "#0F172A",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

